import { language } from "@chef/constants";

export const intl = (
  {
    no: {
      YOUR_STATUS: "Din status",
      READY: "Klar!",
      CALIM_YOUR_REWARD: "Hent din premie!",
      ENDED: "Avsluttet",
      COMPETITION_ENDED_BUT_THERE_WILL_BE_ANOTHER_ONE_SOON:
        "Konkurransen er over for denne gang. Om kort tid kommer det en ny konkurranse - følg med!",
      INVITE_NUM_OF_FRIENDS: (invites: number) => `Verv ${invites} venner`,
      AT_LEAST_NUM_OF_DELIVERIES_NEEDED: (deliveries: number) =>
        `Minst ${deliveries} må motta en leveranse først`,
      WITHIN: "innan",

      PLAN_UPCOMING_DELIVERIES: "Planlegg kommende levering",
      HOW_COMPETITION_WORKS: "Slik fungerer kampanjen",
      RECRUIT_FRIENDS_AND_WIN: "Verv venner og vinner!",
    },
    se: {
      YOUR_STATUS: "Din status",
      READY: "Klar!",
      CALIM_YOUR_REWARD: "Hämta din belöning!",
      ENDED: "Avslutad",
      COMPETITION_ENDED_BUT_THERE_WILL_BE_ANOTHER_ONE_SOON:
        "Tävlingen är över för denna gång. Inom kort blir det en ny tävling - stay tuned!",
      INVITE_NUM_OF_FRIENDS: (invites: number) => `Bjud in ${invites} vänner`,
      AT_LEAST_NUM_OF_DELIVERIES_NEEDED: (deliveries: number) =>
        `Minst ${deliveries} tar en leverans`,
      WITHIN: "innan",
      PLAN_UPCOMING_DELIVERIES: "Planera kommande leverans",
      HOW_COMPETITION_WORKS: "Så funkar kampanjen",
      RECRUIT_FRIENDS_AND_WIN: "Värva vänner och vinn!",
    },
    dk: {
      YOUR_STATUS: "Din status",
      READY: "Klar!",
      CALIM_YOUR_REWARD: "Hent din præmie!",
      ENDED: "Afsluttet",
      COMPETITION_ENDED_BUT_THERE_WILL_BE_ANOTHER_ONE_SOON:
        "Konkurrencen er slut for denne gang. Der kommer en ny konkurrence inden længe, så følg med!",
      INVITE_NUM_OF_FRIENDS: (invites: number) =>
        `Anbefal til ${invites} venner`,
      AT_LEAST_NUM_OF_DELIVERIES_NEEDED: (deliveries: number) =>
        `Mindst ${deliveries} skal modtage en levering`,
      PLAN_UPCOMING_DELIVERIES: "Planlæg næste levering",
      HOW_COMPETITION_WORKS: "Sådan fungerer kampagnen",
      RECRUIT_FRIENDS_AND_WIN: "Anbefal til dine venner og vind!",
    },
  } as const
)[language];
